import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fromDate", "toDate", "errorMessage"]

  connect() {
    this.fromDateTarget.addEventListener('change', this.checkDateRange.bind(this))
    this.toDateTarget.addEventListener('change', this.checkDateRange.bind(this))
  }


  checkDateRange(event) {
    const fromDate = new Date(this.fromDateTarget.value)
    const toDate = new Date(this.toDateTarget.value)
    
    if (toDate < fromDate) {
      event.preventDefault()
      this.errorMessageTarget.classList.remove('hidden');
      this.fromDateTarget.classList.add("border-red-400");      
      this.toDateTarget.classList.add("border-red-400");      
      
    } else {
      this.errorMessageTarget.classList.add('hidden');
      this.fromDateTarget.classList.remove("border-red-400");      
      this.toDateTarget.classList.remove("border-red-400");      
    }
  }
}